import React, { useEffect, useState } from 'react';
import "./TitleComponent.css";

const TitleComponent = () => {
    const [title, setTitle] = useState('ΕLETA Safety Tracking System');

    useEffect(() => {
        const fetchTitle = async () => {
            try {
                const response = await fetch(`${process.env.PUBLIC_URL}/assets/title.txt`);
                if (response.ok) {
                    const text = await response.text();
                    const firstLine = text.split('\n')[0];
                    setTitle(firstLine);
                } else {
                    console.error('Failed to fetch title.txt');
                }
            } catch (error) {
                console.error('Error fetching title:', error);
            }
        };
        fetchTitle();
    }, []);

    return (
        <div>
            {/* <div>
                <img 
                     src={`${process.env.PUBLIC_URL}/assets/eleta.jpg`} 
                    alt="ELETA Logo" 
                    className="title-logo"
                />
            </div> */}
            <div className="title-container">{title}</div>
        </div>
    );
};

export default TitleComponent;
